import { IState } from './state'
import { ActionTree, Store, ActionContext } from 'vuex'
import * as api from '../api'
import { ISearchParams } from '@/api'
import { router } from '../main'

type PayloadType =
	| 'initApp'
	| 'setState'
	| 'search'
	| 'toggleValue'
	| 'setSearchQuery'
	| 'setCurrentPage'
	| 'clearFilters'
	| 'setSort'
	| 'setStartDate'
	| 'setEndDate'
	| 'getSuggestions'
	| 'showSuggestions'
export type ActionPayload<ActionData> = {
	type: PayloadType
	payload: ActionData
}

type ActionHandler<ActionData> = (
	this: Store<IState>,
	injectee: ActionContext<IState, IState>,
	payload: ActionPayload<ActionData>
) => any
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>

export interface IValuePayload {
	name: string
	value: string
	selected: boolean
}
export interface IDatePayload {
	start?: string
	end?: string
}
export interface ISetSearchQueryPayload {
	query: string
	skipSearch?: boolean
}
export interface ISetCurrentPagePayload {
	page: number
	skipSearch?: boolean
}
export interface IClearFiltersPayload {
	skipSearch?: boolean
}
export interface IToggleValuePayload {
	value: IValuePayload
	skipSearch?: boolean
}

/**
 *  Action creators
 */
export const initApp: ActionCreator<IState> = state => ({
	type: 'initApp',
	payload: state
})
export const setSearchQuery: ActionCreator<ISetSearchQueryPayload> = queryPayload => ({
	type: 'setSearchQuery',
	payload: queryPayload
})
export const setStartDate: ActionCreator<string | undefined> = date => ({
	type: 'setStartDate',
	payload: date
})

export const setEndDate: ActionCreator<string | undefined> = date => ({
	type: 'setEndDate',
	payload: date
})

/**
 * Action handlers
 */
const initAppAction: ActionHandler<IState> = ({ commit }, { payload }) => {
	commit({
		type: 'setState',
		payload
	})
}
export const toggleValue: ActionCreator<IToggleValuePayload> = value => ({
	type: 'toggleValue',
	payload: value
})
export const search: ActionCreator<boolean> = reset => ({
	type: 'search',
	payload: reset
})
export const setCurrentPage: ActionCreator<ISetCurrentPagePayload> = payload => ({
	type: 'setCurrentPage',
	payload: payload
})

export const clearFilters: ActionCreator<IClearFiltersPayload> = payload => ({
	type: 'clearFilters',
	payload
})

export const setFiltersFromParams: ActionCreator<string> = filtersString => ({
	type: 'clearFilters',
	payload: filtersString
})

export const setSort: ActionCreator<string> = string => ({
	type: 'setSort',
	payload: string
})

export const getSuggestions: ActionCreator<string> = query => ({
	type: 'getSuggestions',
	payload: query
})

export const showSuggestions: ActionCreator<boolean> = bool => ({
	type: 'showSuggestions',
	payload: bool
})

const showSuggestionsAction: ActionHandler<boolean> = (
	{ commit, dispatch },
	{ payload }
) => {
	commit({
		type: 'showSuggestions',
		payload
	})
}

const getSuggestionsAction: ActionHandler<string> = (
	{ commit, getters, state, dispatch },
	{ payload }
) => {
	api.serchSuggestions(state.endpoints.suggestions, state.query)
		.then(res => {
			commit({
				type: 'setSuggestions',
				payload: res
			})
			if(res.length > 0) {
				dispatch({
					type: 'showSuggestions',
					payload: true
				})
			}
		})
	
}
const setSortAction: ActionHandler<string> = (
	{ commit, dispatch },
	{ payload }
) => {
	commit({
		type: 'setSort',
		payload
	})
	dispatch(search(true))
}
const setFiltersFromParamsAction: ActionHandler<string> = (
	{ commit, dispatch },
	{ payload }
) => {
	const params = JSON.parse(payload)
	console.log(params)
	// commit({
	// 	type: '',
	// 	payload
	// })
}

const clearFiltersAction: ActionHandler<IClearFiltersPayload> = (
	{ commit, dispatch, getters },
	{ payload }
) => {
	commit({
		type: 'clearFilters',
		payload
	})
	router.replace({
		query: getters.getParams
	})
	if (!payload.skipSearch) {
		dispatch(search(true))
	}
}
const toggleValueAction: ActionHandler<IToggleValuePayload> = (
	{ commit, dispatch },
	{ payload }
) => {
	commit({
		type: 'toggleValue',
		payload: payload.value
	})
	if (!payload.skipSearch) {
		dispatch(search(true))
	}
}
const setSearchQueryAction: ActionHandler<ISetSearchQueryPayload> = (
	{ commit, dispatch },
	{ payload }
) => {
	commit({
		type: 'setSearchQuery',
		payload: payload.query
	})
	if (!payload.skipSearch) {
		dispatch(search(true))
	}
}
const setCurrentPageAction: ActionHandler<ISetCurrentPagePayload> = (
	{ commit, dispatch, state },
	{ payload }
) => {
	commit({
		type: 'setCurrentPage',
		payload: payload.page
	})
	
	if (!payload.skipSearch) {
		dispatch(search(false))
	}
}
const searchAction: ActionHandler<boolean> = (
	{ commit, state, getters, dispatch },
	{ payload }
) => {
	if (payload) {
		commit({
			type: 'resetPage',
			payload: undefined
		})
	}

	// Get the identifier from filter and its selected values, use in searchParams
	const categoryFilters = state.categoryFilters.map(cf => {
		return {
			identifier: cf.identifier,
			values: cf.values.filter(v => v.selected).map(v => v.value)
		}
	})
	const sort = state.sort.find(s => s.active)

	// searchParams get the query from state, categoryFilters from above,
	const dateStart = state.date.start
	const dateEnd = state.date.end
	const searchParams = {
		query: state.query,
		categories: categoryFilters,
		date: {
			start: dateStart && new Date(dateStart).getTime(),
			end: dateEnd && new Date(dateEnd).getTime()
		},
		page: state.page,
		sort: sort
	} as ISearchParams

	// Endpoint = ur to search route
	// Send the news hits in the result and the total amount to mutaions
	api.search(state.endpoints.search, searchParams).then(result => {
		commit({
			type: 'setHits',
			payload: result.hits
		})
		// console.log(result.total)
		commit({
			type: 'setTotal',
			payload: result.total
		})
		commit({
			type: 'setPages',
			payload: {
				pages: Math.ceil(Number(state.total) / Number(state.count))
			}
		})
		commit({
			type: 'setSearchedQuery',
			payload: undefined
		})
		dispatch({
			type: 'showSuggestions',
			payload: false
		})
		
	})
	// console.log('totalt antal job: ' + state.total)
	// console.log('totalt antal sidor: ' + state.pages)
	// console.log('current page: ' + state.page)
}

// Set the start date filter and do a new search
const setStartDateAction: ActionHandler<IDatePayload> = (
	{ commit, dispatch },
	{ payload }
) => new Promise((resolve, reject) => {
	if (!payload) {
		reject({ status: 'NOTOK' })
	}
	commit({
		type: 'setStartDate',
		payload
	})
	resolve({ status: 'OK' })
	dispatch(search(true))
})

// Set the end date filter and do a new search
const setEndDateAction: ActionHandler<IDatePayload> = (
	{ commit, dispatch },
	{ payload }
) =>
	new Promise((resolve, reject) => {
		if (!payload) {
			reject({ status: 'NOTOK' })
		}
		commit({
			type: 'setEndDate',
			payload
		})
		resolve({ status: 'OK' })
		dispatch(search(true))
	})

const actions: ActionTree<IState, IState> = {
	initApp: initAppAction,
	toggleValue: toggleValueAction,
	setSearchQuery: setSearchQueryAction,
	search: searchAction,
	setCurrentPage: setCurrentPageAction,
	clearFilters: clearFiltersAction,
	setFiltersFromParams: setFiltersFromParamsAction,
	setSort: setSortAction,
	setStartDate: setStartDateAction,
	setEndDate: setEndDateAction,
	getSuggestions: getSuggestionsAction,
	showSuggestions: showSuggestionsAction,
}

export default actions
